/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ReportTranslationResource} from '../../components/api/resources/resource/report-translation.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-report-translation-route-page',
  template: `
    <adn-report-translation-list-page
      *ngIf="list"
      [list]="list">
    </adn-report-translation-list-page>
  `
})
export class ReportTranslationRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ReportTranslationResource) private readonly ReportTranslation: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey);

    this.adnListHelper.setUpList(this.list, this.ReportTranslation, readOnly, 'fullReportTranslationList', {
      baseTable: 'reportTranslation'
    });
  }
}
